<template>
  <div class="axj-login">
    <div class="axj-login-top">
      <div class="axj-login-top-title">
        <label>
          {{wxUnionId==undefined?"注册/登录":"绑定手机号"}}
        </label>
      </div>
      <div @click="handleWxLogin" class="axj-login-top-icon" v-show="wxUnionId==undefined">
        <i class="icon-erweima"/>
      </div>
    </div>
    <div class="axj-login-body">
      <div class="axj-login-item-normal">
        <div class="axj-login-item-input">
          <el-input placeholder="手机号" @input="handlePhoneInput" @keyup.native="handlePhoneKeyUp" @keydown.native="handlePhoneKeyUp" v-model="certForm.phone"></el-input>
        </div>
      </div>
      <div class="axj-login-item-yzm">
        <div class="axj-login-item-input">
          <el-input placeholder="验证码" v-model="certForm.code"></el-input>
        </div>
        <div class="axj-login-item-button">
          <button @click="sendLetterCode">{{expiresTime>0?expiresTime+'s后重新获取':'获取验证码'}}</button>
        </div>
      </div>
      <div class="axj-login-item-submit">
        <div class="axj-login-item-button">
          <button @click="handleSubmit">{{wxUnionId==undefined?"登录":"下一步"}}</button>
        </div>
      </div>
    </div>
    <div class="axj-login-bottom">
      同意<label>用户协议</label>与<label>隐私政策</label>
    </div>
    <axj-message-prop
      :dialog-show.sync="axjMessagePropData.dialogShow"
      :button-data="axjMessagePropData.buttonData"
      :dialog-message="axjMessagePropData.dialogMessage"
      :dialog-title="axjMessagePropData.dialogTitle"
      :handle-func="axjMessagePropData.handleFunc"
    />
  </div>
</template>

<script>
import commonModels from '@/common/models/common-models'
export default {
  name: "axj-login",
  props:{
    wxUnionId:{
      type:String,
      default:undefined
    },
    title:{
      type:String,
      default:"绑定手机号"
    }
  },
  data(){
    return{
      axjMessagePropData:{
        dialogShow:false,
        buttonData:[
          {
            "label":"去认证",
            "key":"yes",
            "type":""
          },
          {
            "label":"取消",
            "key":"cancel",
            "type":"primary"
          }
        ],
        handleFunc:function (){
        },
        dialogMessage:undefined,
        dialogTitle:"提示"
      },
      certForm:{
        phone:'',
        code:undefined
      },
      expiresTime:0
    }
  },
  methods:{
    initUserInfo(){
      this.$api.commonApi.commonIndex.getUserInfo({uuid: this.$store.getters.getLoginInfo.uuid}).then(res => {
        if (res.code == 200) {
          this.userInfo = res.data
          this.$store.dispatch('saveLoginInfo', {
            uuid: this.$store.getters.getLoginInfo.uuid,
            access_token: this.$store.getters.getLoginInfo.access_token,
            refresh_token:this.$store.getters.getLoginInfo.refresh_token,
            userId: res.data.id
          });
          if (this.userInfo.is_third_party == 0) {
            this.$api.axjWebApi.webAuth.QueryMechanismAuths({
              UserId:this.userInfo.id
            }).then(res=>{
              if(res.data==null||res.data.lists.Status==2){
                this.axjMessagePropData.dialogShow=true
                let that=this
                this.axjMessagePropData.handleFunc=function (v) {
                  if(v==='yes'){
                    that.$router.push({
                      path:"/certification"
                    })
                  }else if('cancel'===v){
                    that.axjMessagePropData.dialogShow=false
                  }
                }
                this.axjMessagePropData.dialogMessage="尊敬的 "+this.userInfo.nickname+"，您尚未进行机构用户认证，无法使用机构用户管理平台，是否去认证？"
              }else if (res.data.lists.Status==0){
                this.axjMessagePropData.buttonData=[{
                  "label":"取消",
                  "key":"cancel",
                  "type":"primary"
                }]
                let that=this
                this.axjMessagePropData.handleFunc=function (res) {
                  if(res==='cancel'){
                    that.axjMessagePropData.dialogShow=false
                  }
                }
                this.axjMessagePropData.dialogShow=true
                this.axjMessagePropData.dialogMessage="尊敬的 "+this.userInfo.nickname+"您已于"+commonModels.formatTime(res.data.lists.CreateTime,'Y年M月D日')+"提请机构用户认证，平台会在7个工作日内完成审核，请您耐心等待！"
              }
            })
          }else{
            this.$store.dispatch("saveUser",
              {
                uid:this.userInfo.id,
                uname:this.userInfo.nickname,
                avatar:this.userInfo.avatar,
                extraShowClubUid:this.userInfo.ExtraShowclubUser.id,
                schoolId:this.userInfo.school_id,
                infoUserUid:this.userInfo.InfoUser.id,
                info:this.userInfo
              })
            this.$router.push({
              path:"/axjMain"
            })
          }
        }
      })
    },
    handleSubmit(){
      let form=this.certForm
      this.$api.commonApi.commonIndex.doLogin({
        identifier:form.phone.replace(/[^\d]/g,""),
        credential:form.code,
        type:"phone",
        device:'pc'
      }).then(res=>{
        //成功
        if(res.code==200){
          //绑定微信
          if(this.wxUnionId){
            //unionId
            this.$api.axjWebApi.webIndex.BindingWechat({
              Uuid:res.data.uuid,
              UnionId:this.wxUnionId
            }).then(res=>{
              if (res.code==200){
                this.initUserInfo()
              }
            },error=>{
            })
            return
          }
          this.initUserInfo()
        }
      },error => {
        if(error.response.data.code==20005){
          this.$emit("do-register",{...form,wxUnionId:this.wxUnionId})
        }
      })
    },
    refreshExpiresTime(){
      setTimeout(res=>{
        this.expiresTime=this.expiresTime-1
        if(this.expiresTime>0){
          this.refreshExpiresTime()
        }
      },1000)
    },
    sendLetterCode(){
      if(this.expiresTime==0){
        this.$api.commonApi.commonIndex.sendLetterCode({
          phone:this.certForm.phone.replace(/[^\d]/g,"")
        }).then(res=>{

        })
        this.expiresTime=99
        this.refreshExpiresTime()
      }
    },
    handleWxLogin(){
      this.$emit("wx-login")
    },
    handlePhoneKeyUp(v){
      if(v.code!='Backspace'){
        if(this.certForm.phone.length==3||this.certForm.phone.length==8){
          this.certForm.phone=this.certForm.phone+" "
        }
      }
    },
    handlePhoneInput(v){
      let lastInput=v.substring(v.length-1,v.length)
      if(isNaN(lastInput)){
        this.certForm.phone=v.substring(0,v.length-1)
      }
      // if(this.loginForm.phone.length==3||this.loginForm.phone.length==8){
      //   this.loginForm.phone=this.loginForm.phone+" "
      // }
      if(this.certForm.phone.length>13){
        this.certForm.phone=this.certForm.phone.substr(0,13);
      }
      // let reg=/^1[3456789]\d{9}$/;
      // if(this.certForm.phone.length>=13){
      //   if(!reg.test(this.certForm.phone.replace(/[^\d]/g,""))){
      //     this.$refs.loginInputPhoneMessage.style.visibility='visible'
      //   }else{
      //     this.$refs.loginInputPhoneMessage.style.visibility='hidden'
      //   }
      // }
    },
  }
}
</script>

<style lang="scss" slot-scope>
.axj-login{
  display: flex;
  flex-flow: column;
  height: 100%;
  .axj-login-top{
    display: flex;
    .axj-login-top-title{
      flex: 10;
      font-size: 22px;
      display: flex;
      color: #000000;
      justify-content: center;
      align-items: center;
      font-family: PingFang SC;
      font-style: normal;
    }
    .axj-login-top-icon{
      display: flex;
      align-items: center;
      .icon-erweima{
        cursor: pointer;
        padding: 0;
        margin-left: 10px;
        margin-top: 8px;
        font-size: 40px;
      }
    }
  }
  .axj-login-body{
    margin-top: 40px;
    .axj-login-item-normal{
      justify-content: center;
      display: flex;
      align-items: center;
      .axj-login-item-input{
        .el-input__inner{
          padding: 0;
          padding-left: 5px;
        }
        width: 80%;
        input{
          color: #000000;
          border: none;
          background:none;
          outline:none;
          border-bottom: 1px solid #DCDFE6;
          width: 100%;
          font-family: PingFang SC;
          font-style: normal;
          font-size: 18px;
          height: 45px;
          border-radius: 0;
        }
        input::-webkit-input-placeholder{
          color: #b5b6bc;
        }
        input:focus{
          border-bottom-color: #00ADB5;;
        }
      }
    }
    .axj-login-item-yzm{
      margin-top: 30px;
      justify-content: center;
      display: flex;
      align-items: center;
      .axj-login-item-input{
        .el-input__inner{
          padding: 0;
          padding-left: 5px;
        }
        width: 60%;
        input{
          color:#000000;
          font-family: PingFang SC;
          font-style: normal;
          border: none;
          background:none;
          outline:none;
          border-bottom: 1px solid #DCDFE6;
          width: 90%;
          font-size: 18px;
          height: 45px;
          border-radius: 0;
        }
        input::-webkit-input-placeholder{
          color: #b5b6bc;
        }
        input:focus{
          border-bottom-color: #00ADB5;;
        }
      }
      .axj-login-item-button{
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        button{
          cursor: pointer;
          border: 0;
          outline: none;
          height: 40px;
          border-radius: 25px;
          width: 90%;
          background: linear-gradient(to top, #85d8db 0%, #00adb5 50%);
          color: #ffffff;
        }
      }
    }
    .axj-login-item-submit{
      margin-top: 60px;
      justify-content: center;
      display: flex;
      align-items: center;
      .axj-login-item-button{
        width: 80%;
        display: flex;
        justify-content: center;
        button{
          cursor: pointer;
          border: 0;
          outline: none;
          font-size: 18px;
          height: 50px;
          border-radius: 25px;
          width: 100%;
          background: linear-gradient(to top, #85d8db 0%, #00adb5 50%);
          color: #ffffff;
        }
      }
    }
  }
  .axj-login-bottom{
    width: 100%;
    display: flex;
    margin-top: 40px;
    justify-content: center;
    label{
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/axj-web-certs/components/axj-login/index.vue